import { decode } from 'html-entities';

export const parseAndSplitHtmlText = (input: string) => {
  // Double decode to handle quirky hebaviours of some characters being saved on the backend, so far we know:
  // " saved as &amp;quote; instead of &quote;
  // > saved as &amp;gt; instead of &gt;
  // < saved as &amp;lt; instead of &lt;
  // & saved as &amp;amp; instead of &amp;
  const decodedInput = decode(decode(input));
  return decodedInput.split('<br />').filter((line) => line.trim() !== '');
};
